import React from "react";
import { useSelector } from "react-redux";

import { useEmailDataContext } from "./dataContext";
import { useErrorContext } from "./errorContext";
import { useScreenContext } from "./screenContext";
import { getEmail } from "../core/getNode";
import { getTemplateByIdentity } from "../utils/helpers";

import { Button } from "@mui/material";
import Logout from "./logout";

export default function AppHeader() {
  const user = useSelector((state) => state.authReducer.user);
  const system = useSelector((state) => state.systemReducer);
  const config = useSelector((state) => state.configReducer);

  const {
    selectedTemplate,
    selectedBrand,
    selectedLanguage,
    presentationsObject,
    newsObject,
    documentsObject,
    webformsObject,
    eventsObject,
  } = useEmailDataContext();
  const { setLoading, setError, setErrorMessage } = useErrorContext();
  const { currentScreen } = useScreenContext();

  const emailConfigured = () => {
    if (selectedTemplate && selectedBrand && selectedLanguage) {
      return true;
    } else {
      return false;
    }
  };

  const createEmail = () => {
    setLoading(true);
    setError(false);
    setErrorMessage("");

    const templateData = getTemplateByIdentity(selectedTemplate, config.templates);

    let data = {
      template: selectedTemplate,
      brand: selectedBrand,
      language: selectedLanguage,
      presentation_ids: presentationsObject.join(","),
      news_ids: newsObject.join(","),
      document_ids: documentsObject.join(","),
      webform_ids: webformsObject.join(","),
      event_ids: eventsObject.join(","),
      uid: user.current_user.uid,
      subdomain: system.subdomain,
    };

    templateData.contentTypes.forEach((type) => {
      if (type.endpoint) {
        data[`${type.bundle}_endpoint`] = type.endpoint;
      }
    });

    if (
      presentationsObject.length === 0 &&
      newsObject.length === 0 &&
      documentsObject.length === 0 &&
      webformsObject.length === 0 &&
      eventsObject.length === 0
    ) {
      setError(true);
      setErrorMessage("Please choose the content you would like to insert.");
      setLoading(false);
    } else {
      getEmail(data)
        .then((response) => {
          Office.context.mailbox.item.body.setAsync(
            response.data.html,
            { coercionType: Office.CoercionType.Html },
            function (result) {
              if (result.status === Office.AsyncResultStatus.Failed) {
                setError(true);
                setErrorMessage("Sorry, the email could not be created. Please try again.");
                console.log("createEmail error");
              } else {
                Office.context.ui.closeContainer();
              }
            }
          );

          setLoading(false);
        })
        .catch((error) => {
          setError(true);
          setErrorMessage("Sorry, the email could not be created. Please try again.");
          setLoading(false);
        });
    }
  };

  return (
    <div className="app-content-menu-wrapper">
      <div id="app-content-menu" className={`app-content-menu ${emailConfigured() ? "create-email" : ""}`}>
        <>
          <Button
            color="success"
            variant="contained"
            onClick={() => createEmail()}
            sx={{
              fontWeight: "500",
              fontSize: "14px",
              lineHeight: "14px",
              height: "35px",
              textTransform: "none",
              backgroundColor: "#20BF55",
              marginLeft: "8px",
              visibility: emailConfigured() && currentScreen === "/content" ? "visible" : "hidden",
            }}
          >
            Create email
          </Button>
          <Logout user={user} />
        </>
      </div>
    </div>
  );
}
